export default (p) => `
  .react-select__control {
    border: 1px solid ${p.theme.colors.borders};
    background-color: ${p.theme.colors.background};
  }
  .react-select__control--is-focused {
    border-color: ${p.theme.colors.focus};
  }
  .react-select__indicators {
    outline: 0;
  }
  .react-select__input,
  .react-select__single-value,
  .react-select__value-container {
    font-size: ${p.theme.font.size.small};
    color: ${p.theme.colors.text};
  }
  .react-select__placeholder {
    white-space: nowrap;
    color: ${p.theme.colors.textLight};
  }
  .react-select__menu-list {
    padding: 0;
    background-color: ${p.theme.colors.backgroundShaded};
  }
  .react-select__option--is-focused {
    background-color: ${
      p.theme.mode === 'light' ? p.theme.colors.blue85 : p.theme.colors.blue35
    };
  }
  .react-select__option--is-selected {
    color: ${p.theme.colors.text};
    background-color: ${
      p.theme.mode === 'light' ? p.theme.colors.blue75 : p.theme.colors.blue
    };
  }
  input {
    height: auto;
  }
`;
